<script setup lang="ts">
const emit = defineEmits(['cancel'])
const { t } = useI18n()
const accountList = ref([{
  name: t('账户名称'),
  value: t('广州数说故事信息科技有限公司'),
  isCopy: false,
}, {
  name: t('银行账号'),
  value: '722471347348',
  isCopy: false,
}, {
  name: t('银行账户'),
  value: t('中国银行广州番禺天安科技支行'),
  isCopy: false,
}])
</script>

<template>
  <div p-24>
    <div class="relative w-full pb-16 text-center text-16 text-[--color-text-1] font-500">
      {{ $t('企业对公账号转账') }}
      <span class="absolute right--8 top--8 h-20 w-20 flex cursor-pointer items-center justify-center text-18 text-[--color-text-1] hover:op-80" @click="emit('cancel')"><i class="icon-shanchu" /></span>
    </div>
    <div mb-24 mt-8 flex flex-col gap-12 text-14>
      <div v-for="item in accountList" :key="item.name" flex justify-between class="text-[--color-text-3]">
        <div flex-1>
          {{ item.name }}：<span class="text-[--color-text-1]">{{ item.value }}</span>
        </div>
        <BtnsCopy
          icon="icon-fuzhi !text-[--color-brand-6]"
          :text="item.value"
        />
      </div>
    </div>
    <div class="text-12 text-[--color-text-4] lh-24px">
      {{ $t('对公转账到账时间可能受银行处理时间影响，建议采用在线支付；') }}<br>
      {{ $t('请通过网银转账或自行到银行进行转账，转账成功后请将汇款底单拍子或截图发送给客服；') }}<br>
      {{ $t('确认汇款到账后即会为您开通对应会员，开通后您可向客服索取发票。') }}。
    </div>
    <div mt-24 text-center>
      <a-button type="primary" shape="round" size="small" class="w-98" @click="emit('cancel')">
        {{ $t('我知道了') }}
      </a-button>
    </div>
  </div>
</template>

<style lang="less">

</style>
